export function handleCharacterLimitChange(
  value: string,
  maxLength: number,
  onValidChange: (value: string) => void,
  setError: (message: string | undefined) => void,
): boolean {
  if (value.length > maxLength) {
    setError(
      `You exceeded the character limit. Maximum limit is ${maxLength}.`,
    );
    return false;
  }

  setError(undefined);
  onValidChange(value);
  return true;
}